import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import translationRu from './locales/ru.json';
import translationUz from './locales/uz.json';
import { DEFAULT_LANGUAGE } from './constants';

const resources = {
  ru: {
    translation: translationRu,
  },
  uz: {
    translation: translationUz,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };
